module.exports = __webpack_public_path__ + "static/img/pc端展示.5cfeb096.png";